import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

const Card = styled(Link)`
  display: flex;
  flex-direction: column;
  background: var(--nd-surface);
  border: 1px solid var(--nd-border);
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  text-decoration: none !important;
  color: inherit !important;
  transition: border-color 250ms cubic-bezier(0.25, 0.1, 0.25, 1);
  &:hover { border-color: var(--nd-border-visible); }
`;

const Kicker = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin-bottom: 12px;
`;

const Title = styled.h3`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: var(--nd-text-display);
  line-height: 1.3;
  margin: 0 0 8px;
`;

const Desc = styled.p`
  font-family: 'Space Grotesk', sans-serif;
  font-size: 14px;
  color: var(--nd-text-secondary);
  line-height: 1.5;
  margin: 0 0 16px;
  flex-grow: 1;
`;

const MetaRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const Hours = styled.span`
  font-family: 'Doto', 'Space Mono', monospace;
  font-size: 36px;
  font-weight: 700;
  color: var(--nd-text-display);
  line-height: 1;
  letter-spacing: -0.02em;
`;

const HoursLabel = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-disabled);
  margin-left: 6px;
`;

const Lessons = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  color: var(--nd-text-secondary);
  letter-spacing: 0.04em;
`;

const DIFFICULTY_COLOR = {
  beginner: "var(--nd-success)",
  intermediate: "var(--nd-warning)",
  advanced: "var(--nd-accent)",
};

const DifficultyBadge = styled.span`
  font-family: 'Press Start 2P', 'Space Mono', monospace;
  font-size: 9px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${(p) => DIFFICULTY_COLOR[p.level] || "var(--nd-text-primary)"};
  border: 1px solid ${(p) => DIFFICULTY_COLOR[p.level] || "var(--nd-border-visible)"};
  padding: 4px 8px;
  border-radius: 4px;
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid var(--nd-border);
`;

const Instructor = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  color: var(--nd-text-secondary);
  letter-spacing: 0.04em;
`;

const StartLink = styled.span`
  font-family: 'Space Mono', monospace;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--nd-text-display);
`;

const ElearningCard = ({ module }) => (
  <Card to={`/academy/elearning/${module.slug}/`} aria-label={`Open course ${module.title}`}>
    <Kicker>{module.kicker}</Kicker>
    <Title>{module.title}</Title>
    <Desc>{module.description}</Desc>
    <MetaRow>
      <div>
        <Hours>{module.durationHours}h</Hours>
        <HoursLabel>video</HoursLabel>
      </div>
      <Lessons>{module.lessonCount} lessons</Lessons>
      <DifficultyBadge level={module.difficulty}>{module.difficulty}</DifficultyBadge>
    </MetaRow>
    <Footer>
      <Instructor>{module.instructor}</Instructor>
      <StartLink>Start course →</StartLink>
    </Footer>
  </Card>
);

export default ElearningCard;
